
import React, { useState, useEffect } from 'react';
import {
  Box, Button, Card, Grid,
  Dialog, DialogContent, DialogTitle,
  Tabs, Tab,
  Typography, Container, Autocomplete, TextField, FormControl, FormHelperText,
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Header from '../Header';
import Footer from '../Footer';
import { DecorativeCorner } from '../../common/DecorativeCorner';
import { styles } from '../../styles/styles';
import StarIcon from '@mui/icons-material/Star';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { FontStyles } from '../../styles/FontStyles';
import { matrimoneyEndPoints } from '../../../services/apis';
import {
  StyledTextField,
  StyledFormControl,
  FormContainer,
  StyledButton,
  FormGrid,
} from "../../common/FormStyles";
import PhoneInput from 'react-phone-input-2';
import {
  getFamilyStatusList,
  getFamilyTypeList,
  getCitiesList,
  getReligionsList,
  getCastesList,
  updateFamilyDetails,
  getHealthConditionList,
  getProfileDetails, getCountriesList, getStatesList, getDistrictsList,
  getStatesListByCountry,
  getDistrictsListByState,
  getCitiessListByDistrict,
  getRelationsList,
  getEducationList,
  getSourceList,
  nearestBranch,
  getDesignationList, getEmployedInList
} from "../../../services/operations/userOperations";
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from 'axios';

const Careers = () => {

  const careerTabs = [
    "Personal Details",
    "Contact Details",
    "User Files",
  ];
  // const Role = [
  //   { id: 1, name: "Workers" },
  //   { id: 2, name: "Manager" },
  //   { id: 3, name: "BPO" },
  // ];

  const Gender = [
    { id: 1, name: "Male" },
    { id: 2, name: "Female" },

  ];
  const maritialstatus = [
    { id: 1, name: "UnMarried" },
    { id: 2, name: "Married" },
  ]
  const Educationlevel = [
    { id: 1, name: "Regular" },
    { id: 2, name: "Distance" }
  ]
  const StatusList = [
    { id: 1, name: "ENABLE" },
    { id: 2, name: "DisABLE" }
  ];
  // State declaration
  const [open, setOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [selectedRole, setSelectedRole] = useState(null);
  const [phone, setPhone] = useState('');
  const [officeNumber, setOfficeNumber] = useState('');
  const [gender, setGender] = useState(null);
  const [marrital, setMarrital] = useState(null);
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [religionlist, setReligionList] = useState([]);
  const [selectedReligion, setSelectedReligion] = useState(null);
  const [castelist, setCasteList] = useState([]);
  const [seletedCate, setSeletedCaste] = useState([]);
  const [formValues, setFormValues] = useState({
    // country: null,
    state: null,
    // distric: null,
    city: null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [education, setEducation] = useState(null)
  const [cities, setCities] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [aadhar, setAadhar] = useState('');
  const [expYears, setExpYears] = useState(null);
  const [expMonths, setExpMonths] = useState(null);
  const [pincode, setPincode] = useState('');
  const [errors, setErrors] = useState({});
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null)
  const [educationList, setEducationList] = useState([]);
  const [seletedEducationlist, setEducationlist] = useState([]);
  const [fathernumber, setFathernumber] = useState('');
  const [contactRefrencenumber, setContactRefrenceNumber] = useState('');
  const [source, setSource] = useState([]);
  const [seletedsource, setSeletedSource] = useState([]);
  const [branch, setBranch] = useState([]);
  const [seletedbranch, setSelectedBranch] = useState([]);
  const [address, setAddress] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [fatherName, setFatherName] = useState("");
  const [fatherAdress, setFatherAdress] = useState("");
  const [referenceName, setReferenceName] = useState("");
  const [referenceAddress, setReferenceAddress] = useState("");
  const [joiningDate, setJoiningDate] = useState("");
  const [personalEmail, setPersonalEmail] = useState("");
  const [Role, setRole] = useState([]);
  const [sscimage, setSscimage] = useState(null);
  const [AadharCard, setAadharCard] = useState(null);
  const [Pancard, setPancard] = useState(null);
  const [HigherCertificate, setHigherCertificate] = useState(null);
  const [BankPassBook, setBankPassBook] = useState(null);
  const [ProfilePhoto, setProfilePhoto] = useState(null);
  const [createStaff, setCreateStaff] = useState("");
  const [createdStaffId, setCreatedStaffId] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [husbandname, sethusbandName] = useState("");
  const [husbandsurname, sethusbandSurname] = useState("");
  const [husbandAddress, setHusbandAddress] = useState("");
  const [husbandnumber, setHusbandNumber] = useState("");
  const Scchandlechange = (e) => setSscimage(e.target.files[0]);
  const AadharCardhandlechange = (e) => setAadharCard(e.target.files[0]);
  const Pancardhandlechange = (e) => setPancard(e.target.files[0]);
  const HigherCertificatehandlechange = (e) => setHigherCertificate(e.target.files[0]);
  const PassBookhandlechange = (e) => setBankPassBook(e.target.files[0]);
  const Profilehandlechange = (e) => setProfilePhoto(e.target.files[0]);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleTabChange = (event, newValue) => setTabValue(newValue);
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setSelectedImage(imageUrl);
    }
  };

  const handleAadharChange = (e) => {
    const value = e.target.value;
    // Allow only digits, max length 12
    if (/^\d{0,12}$/.test(value)) {
      setAadhar(value);
    }
  };
  const handleNumberInput = (setter) => (e) => {
    const value = e.target.value;
    if (!isNaN(value)) {
      setter(Number(value));
    }
  };
  // const fetchCitiesListByState = async (stateId) => {
  //   if (!stateId) return;
  //   try {
  //     const response = await getCitiessListByDistrict(stateId);
  //     if (response.status) {
  //       setCities(response.data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching cities:", error);
  //   }
  // };
  // const handleCountryChange = (event, value) => {
  //   setFormValues(prev => ({
  //     ...prev,
  //     // country: value,
  //     state: null,
  //     distric: null,

  //     city: null
  //   }));
  //   if (value?.id) {
  //     fetchStatesListByCountry(value.id);
  //   } else {
  //     setStates([]);
  //     setCities([]);
  //   }
  // };

  // const handleStateChange = (event, value) => {
  //   setFormValues(prev => ({
  //     ...prev,
  //     state: value,
  //     distric: null,
  //     city: null
  //   }));

  //   if (value?.id) {
  //     fetchDistrictsListByState(value.id);  // 👉 Fetch districts
  //   } else {
  //     setDistricts([]);
  //     setCities([]);
  //   }
  // };

  // const handleCityChange = (event, value) => {
  //   setFormValues(prev => ({ ...prev, city: value }));
  // };
  // const fetchDistrictsListByState = async (stateId) => {
  //   if (!stateId) return;
  //   try {
  //     const response = await getDistrictsListByState(stateId);
  //     if (response.status) {
  //       setDistricts(response.data);
  //       setCities([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching districts:", error);
  //   }
  // };
  // const handleDistrictChange = (event, value) => {
  //   setFormValues(prev => ({
  //     ...prev,
  //     distric: value,
  //     city: null
  //   }));

  //   if (value?.id) {
  //     fetchCitiesListByState(value.id);
  //   } else {
  //     setCities([]);
  //   }
  // };
  const fetchStatesList = async () => {
    try {
      const response = await getStatesList();
      if (response.status) {
        setStates(response.data);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  const fetchCitiesListByState = async (stateId) => {
    if (!stateId) return;
    try {
      const response = await getCitiessListByDistrict(stateId);
      if (response.status) {
        setCities(response.data);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const handleStateChange = (event, value) => {
    setFormValues(prev => ({
      ...prev,
      state: value,
      city: null,
    }));

    if (value?.id) {
      fetchCitiesListByState(value.id);
    } else {
      setCities([]);
    }
  };

  const handleCityChange = (event, value) => {
    setFormValues(prev => ({ ...prev, city: value }));
  };

  // useEffect(() => {
  //   const fetchInitialData = async () => {
  //     try {
  //       setIsLoading(true);

  //       const countriesResponse = await getCountriesList();
  //       if (countriesResponse.status) {
  //         setCountries(countriesResponse.data);
  //       }

  //     } catch (error) {
  //       console.error("Error fetching initial data:", error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchInitialData();
  // }, []);
  useEffect(() => {
    fetchStatesList();
    fetchCitiesListByState();
  }, [])
  const ReligionList = async () => {
    try {
      const response = await getReligionsList();
      if (response.status) {
        setReligionList(response.data);
      }
    } catch (error) {
      console.log("Data not found for religion:", error);
    }
  };

  const Castelist = async () => {
    try {
      const response = await getCastesList();
      if (response.status) {
        setCasteList(response.data);
      }
    }
    catch (error) {
      console.log("data not found caste list:", castelist);
    }
  }
  const EducationlistFetching = async () => {
    try {
      const res = await getEducationList();
      if (res.status) {
        setEducationList(res.data)
      }
    } catch (error) {
      console.log("data not found educationlist:", educationList);

    }
  }
  const sourceListFetching = async () => {
    try {
      const res = await getSourceList();
      if (res.status) {
        setSource(res.data)
      }
    } catch {
      console.log("data not found source list:", setSource);

    }
  }
  const Branchlist = async () => {
    try {
      const res = await nearestBranch();
      if (res.status) {
        setBranch(res.data)
      }
    } catch {
      console.log("data not found branchlist:", branch);
    }
  }
  // const fetchStatesListByCountry = async (countryId) => {
  //   if (!countryId) return;
  //   try {
  //     const response = await getStatesListByCountry(countryId);
  //     if (response.status) {
  //       setStates(response.data);
  //       setCities([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching states:", error);
  //   }
  // };
  // store by token in sessionstarage

  // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsInVzZXJUeXBlIjoiU1VQRVJfQURNSU4iLCJicmFuY2hJZCI6bnVsbCwiZnJhbmNoYXNlSWQiOm51bGwsImlwIjoiOjpmZmZmOjEyNy4wLjAuMSIsInVzZXJBZ2VudCI6Ik1vemlsbGEvNS4wIChXaW5kb3dzIE5UIDEwLjA7IFdpbjY0OyB4NjQpIEFwcGxlV2ViS2l0LzUzNy4zNiAoS0hUTUwsIGxpa2UgR2Vja28pIENocm9tZS8xMzYuMC4wLjAgU2FmYXJpLzUzNy4zNiIsImlhdCI6MTc0NzMyMTU0OSwiZXhwIjoxNzQ4MTg1NTQ5fQ.To-_Ccz8QOptD-OuW6JzXD7-cJUpwmYbnuZwKK-rMWo"; 
  const token = localStorage.getItem("token")

  const validate = () => {
    const newErrors = {};
    if (aadhar.length !== 12) {
      newErrors.aadhar = "Aadhar number must be exactly 12 digits.";
    }
    if (!contactRefrencenumber) newErrors.contactRefrencenumber = "contact Refrence Number is required."
    if (!fathernumber) newErrors.fathernumber = "fathernumber is required."
    if (!status?.id) newErrors.status = "Status  is required."
    // if (!joiningDate) newErrors.joiningDate = "JoiningDate  is required."
    if (!seletedsource?.id) newErrors.seletedsource = "Source  is required."
    if (!referenceAddress) newErrors.referenceAddress = "ReferenceAddress  is required."
    if (!referenceName) newErrors.referenceName = "ReferenceName is required."
    if (!fatherAdress) newErrors.fatherAdress = "FatherAdress is required."
    if (!expYears) newErrors.expYears = "Please enter experience years.";
    if (!expMonths) newErrors.expMonths = "Please enter experience months.";
    if (!seletedEducationlist?.id) newErrors.seletedEducationlist = "Education detalies is required.";
    if (!address) newErrors.address = "Address is required."
    if (!fatherName) newErrors.fatherName = "FatherName is required."

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const showSpouseFields = marrital?.id === 2 && gender?.id !== 1;
  const validateforpersonal = () => {
    const newErrors = {};
    if (!email) {
      newErrors.email = "Email is required.";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      newErrors.email = "Invalid email format.";
    }
    if (!name) newErrors.name = "Name is required.";
    if (!surname) newErrors.surname = "Surname is required.";
    if (!phone) newErrors.phone = "Mobile number is required.";
    if (!seletedbranch?.id) newErrors.seletedbranch = "Branch is required.";
    // if (!selectedRole?.id) newErrors.selectedRole = "Role is required.";
    if (!gender?.name) newErrors.gender = "Gender is required.";
    if (!ProfilePhoto) newErrors.ProfilePhoto = "Upload Profile Picture is required."
    if (!marrital?.name) newErrors.marrital = "MaritalStatus is required.";
    if (!selectedReligion?.id) newErrors.selectedReligion = "Religion is required.";
    if (!seletedCate?.id) newErrors.seletedCate = "Cast is required. ";
    if (!dateOfBirth) newErrors.dateOfBirth = " Date Of Birth is required.";
    if (!education?.name) newErrors.education = " Education is required.";
    // if (!formValues.country?.id) newErrors.country = "country is required.";
    if (!formValues.state?.id) newErrors.state = "State is required.";
    if (!formValues.city?.id) newErrors.city = "City is required.";
    if (showSpouseFields) {
      if (!husbandname) newErrors.husbandname = "Husbandname is required.";
      if (!husbandsurname) newErrors.husbandsurname = "Husbandsurname is required.";
      if (!husbandnumber) newErrors.husbandnumber = "Husband Moblie Number is required.";
      if (!husbandAddress) newErrors.husbandAddress = "Husband Address is required."
    }
    // if (!formValues.distric?.id) newErrors.distric = "distric is required.";
    // if (!officeNumber) newErrors.officeNumber = "OfficeNumber is required."
    // if (!personalEmail) {
    //   newErrors.personalEmail = "Email is required.";
    // } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(personalEmail)) {
    //   newErrors.personalEmail = "Invalid email format.";
    // }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const RoleListFetching = async () => {
    try {
      const res = await axios.post(
        matrimoneyEndPoints.GET_ROLE_LIST,
        { meta: true },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status) {
        setRole(res.data.data);
      }
    } catch (error) {
      console.log("data not found Role:", error);
    }
  };
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const CreateStaff = async () => {
    const payload = {
      name: name,
      surname: surname,
      mobileNumberCountryCode: "+91",
      mobileNumber: phone,
      email: email,
      gender: gender?.name || "",
      maritalStatus: marrital?.name?.toLowerCase() || "",
      dateOfBirth: dateOfBirth || "",
      educationType: education?.name || "",
      status: status?.id || 0,
      branch_id: seletedbranch?.id || "",
      franchise_id: 2,
      caste_id: seletedCate?.id || "",
      religion_id: selectedReligion?.id || "",
      state_id: formValues.state?.id || "",
      city_id: formValues.city?.id || "",
      address: address || "",
      aadharNumber: aadhar || "",
      pastExperienceYears: Number(expYears) || 0,
      pastExperienceMonths: Number(expMonths) || 0,
      fatherName: fatherName || "",
      fatherContactCountryCode: "",
      fatherContact: fathernumber || "",
      fatherAddress: fatherAdress || "",
      referenceName: referenceName || "",
      referenceContactCountryCode: "",
      referenceContact: contactRefrencenumber || "",
      referenceAddress: referenceAddress || "",
      education_id: seletedEducationlist?.id || "",
      source_id: seletedsource?.id || "",
      husbandName: husbandname || "",
      husbandSurname: husbandsurname || "",
      husbandNumber: husbandAddress || "",
      husbandAddress: husbandnumber || "",
    };

    try {
      const res = await axios.post(
        matrimoneyEndPoints.GET_CREATE_STAFF,
        payload,
      );
      if (res.status) {
        setCreateStaff(res.data);
      }
      if (res?.data?.message) {
        setMessage(res.data.message);
      }
      if (res?.data?.status) {
        setMessageType("success");
      }
      if (res?.data?.data?.id) {
        const id = res.data.data.id;
        setCreatedStaffId(id);
        return id;
      }
      else {
        setMessageType("error");
      }
    } catch (error) {
      setMessage("Something went wrong. Please upload all staff details.");
      setMessageType("error");
      console.error("createStaff error:", error);
    }
  };
  useEffect(() => {
    ReligionList();
    Castelist();
    RoleListFetching();
    EducationlistFetching();
    sourceListFetching();
    Branchlist();
  }, [])
  const uploadCertificates = async (id) => {
    const formData = new FormData();
    // formData.append('id', Number(createdStaffId));
    formData.append('id', Number(id));
    formData.append('ssccertificate', sscimage);
    formData.append('aadharcardphoto', AadharCard);
    formData.append('pancard', Pancard);
    formData.append('highercertificate', HigherCertificate);
    formData.append('passbook', BankPassBook);
    formData.append('profile', ProfilePhoto);
    try {
      const res = await axios.post(matrimoneyEndPoints.UPLOAD_STAFF_DOCUMNENTS, formData);
      return res?.data ?? { status: true, message: "Uploaded successfully" };
    } catch (error) {
      console.error("Upload error:", error);
      return {
        status: false,
        message: error?.response?.data?.message || "Upload failed",
      };
    }
  };
  console.log("createdStaffId:", createdStaffId);
  const handlenext = () => {
    if (validateforpersonal()) {
      setTabValue(1);
    }
  }
  const handleNext = async () => {
    const id = await CreateStaff();
    if (validate() && id) {
      await uploadCertificates(id);
      setTabValue(2);
    }
  };
  const handleSubmit = async () => {
    if (!createdStaffId) {
      setSnackbarMessage("Staff Detalies not found. Please Complete staff Form first.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const response = await uploadCertificates(createdStaffId);

    const status = response?.status ?? false;
    const message = response?.message ?? "Something went wrong";

    setSnackbarMessage(message);
    setSnackbarSeverity(status ? "success" : "error");
    setSnackbarOpen(true);
    if (!!setSnackbarOpen) {
      setOpen(false)
    }
  };
  console.log("onclick", setTabValue);

  return (
    <>
      <Header />

      <Box
        sx={{
          marginTop: { xs: "20%", sm: "10%", md: "5%", lg: "10%", xl: "10%" },
          paddingX: 2,
          marginBottom: "50px",
        }}
      >
        <Snackbar
          open={!!message}
          autoHideDuration={3000}
          onClose={() => setMessage("")}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            onClose={() => setMessage("")}
            severity={messageType || "info"}
            sx={{ width: '100%' }}
          >
            {message}
          </Alert>
        </Snackbar>

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={4000}
          onClose={() => setSnackbarOpen(false)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Card sx={{ ...styles.carrercard, boxShadow: 3 }}>
              <DecorativeCorner sx={{ top: -20, left: -20 }} />
              <DecorativeCorner sx={{ top: -20, right: -20 }} />
              <DecorativeCorner sx={{ bottom: -20, right: -20 }} />
              <DecorativeCorner sx={{ bottom: -20, left: -20 }} />

              <Typography sx={FontStyles.heading1}>
                Careers At Annapurna Marriages
              </Typography>

              <Box sx={{ border: "3px solid #C1721F", padding: "20px" }}>
                <Typography sx={{ ...FontStyles.aboutText }}>

                  Are you looking for a company that values your expectations and opinions? At Annapurna Marriages, we ensure a work environment with strong values in marriage services. If you wish to be part of an exciting and fun-filled team, please follow the steps to upload your career form. Make sure the following documents are ready:
                </Typography>

                <ul style={{ paddingLeft: '0' }}>
                  {[
                    'Higher Education Certificate copy',
                    'SSC Certificate copy',
                    'Aadhar Card Scan Copy',
                    'Pan Card Scan Copy',
                    'Bank Passbook Xerox copy',
                    'Passport Size photo'
                  ].map((text, index) => (
                    <Typography key={index} sx={{ ...FontStyles.careerkeypoints }}>
                      <StarIcon fontSize="small" sx={{ mr: 1, color: "#C1721F" }} />
                      {text}
                    </Typography>
                  ))}
                </ul>
                <Typography sx={{ ...FontStyles.aboutText }}>

                  Please ensure all files are in <span style={{ color: "#C1721F", fontSize: "20px" }}>.jpeg, .jpg, or .png</span> format.<br />
                  Candidates providing all documents will be preferred for interview calls.<br />
                  We will verify your email & mobile number (<span style={{ color: "#C1721F", fontSize: "20px" }}>verified candidates get priority</span>).
                  <span style={{ color: "red", marginLeft: "10px" }}>You will have 20 minutes to complete the form.</span>
                </Typography>

                <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 1 }}>
                  <Typography sx={{ ...FontStyles.aboutText }}>

                    If you're ready to fill the form
                  </Typography>

                  <Button onClick={handleClickOpen} sx={styles.career}>
                    <PersonAddIcon /> Register Here
                  </Button>
                </Box>
                <Dialog open={open} fullWidth maxWidth="md" onClose={handleClose}>
                  <DialogTitle sx={{ fontFamily: '"Inter var"', }}>Agent Registration</DialogTitle>
                  <Box sx={{ position: "relative", display: "inline-block" }}>
                    <Button
                      onClick={handleClose}
                      sx={{
                        position: "absolute",
                        top: "-62px",
                        right: { xs: "-0px", md: "0px" },
                        minWidth: "52px",
                        height: "32px",
                        backgroundColor: "#C1721F",
                        color: "white",
                        fontFamily: '"Inter var"',
                        fontWeight: "bold",
                        fontSize: "14px",
                        padding: 2,
                        zIndex: 10,
                        "&:hover": {
                          backgroundColor: "#a55817",
                        },
                      }}
                    >
                      Close
                    </Button>
                  </Box>
                  <DialogContent>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                      <Tabs
                        value={tabValue}
                        // onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        centered
                      >
                        {careerTabs.map((label, index) => (
                          <Tab
                            key={index}
                            label={label}
                            value={index}
                            sx={{
                              fontWeight: 'bold', fontSize: '13px', color: 'black', fontFamily: '"Inter var"',
                            }}
                          />
                        ))}
                      </Tabs>
                    </Box>
                    {tabValue === 0 && (
                      <Card sx={{ ...styles.carrercardPopup, boxShadow: 10, p: 2 }}>
                        <DecorativeCorner sx={{ top: -20, left: -20 }} />
                        <DecorativeCorner sx={{ top: -20, right: -20 }} />
                        <DecorativeCorner sx={{ bottom: -20, right: -20 }} />
                        <DecorativeCorner sx={{ bottom: -20, left: -20 }} />
                        <Box sx={{ border: "2px solid #C1721F", padding: "20px" }}>
                          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                            <Box
                              sx={{
                                width: 120,
                                height: 120,
                                borderRadius: '50%',
                                border: '2px dashed #ccc',
                                overflow: 'hidden',
                                position: 'relative',
                                cursor: 'pointer',
                                backgroundColor: '#f5f5f5',
                              }}
                            >

                              {ProfilePhoto ? (
                                <img
                                  // src={ProfilePhoto}
                                  src={URL.createObjectURL(ProfilePhoto)}
                                  alt="Uploaded"
                                  style={{ width: '100%', height: '100%', objectFit: 'contain', }}
                                />
                              ) : (
                                <Box
                                  sx={{
                                    width: '100%',
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <PhotoCamera sx={{ fontSize: 40, color: '#C1721F' }} />
                                </Box>
                              )}
                              <input
                                type="file"
                                accept="image/*"
                                // onChange={handleImageChange}
                                onChange={Profilehandlechange}
                                error={!!errors.ProfilePhoto}
                                helperText={errors.ProfilePhoto}
                                style={{
                                  opacity: 0,
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  height: '100%',
                                  width: '100%',
                                  cursor: 'pointer',
                                }}
                              />
                            </Box>
                          </Box>
                          <Typography sx={{
                            textAlign: "center", mb: 1, fontWeight: 700,
                            fontFamily: '"Inter var"',

                          }}>Upload Your Profile Picture</Typography>
                          {errors.ProfilePhoto && (
                            <Typography sx={{ color: 'red', fontSize: 12, textAlign: 'center', mb: 1 }}>
                              {errors.ProfilePhoto}
                            </Typography>
                          )}
                          <Grid container spacing={2}>
                            {/* <Grid item xs={12} md={6}>
                              <Autocomplete options={branch}
                                getOptionLabel={(o) => o.name || ""}
                                value={seletedbranch}
                                onChange={(e, v) => setSelectedBranch(v)}
                                renderInput={(params) =>
                                  <StyledTextField {...params}
                                    error={!!errors.seletedbranch}
                                    helperText={errors.seletedbranch}
                                    label="Select branch" variant="outlined" size="small"
                                    fullWidth />} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Autocomplete options={Role}
                                getOptionLabel={(option) => option.name}
                                value={selectedRole}
                                onChange={(e, v) => setSelectedRole(v)}
                                renderInput={(params) => <StyledTextField {...params}
                                  error={!!errors.selectedRole}
                                  helperText={errors.selectedRole}
                                  label="Select Role" variant="outlined" size="small" fullWidth />} />
                            </Grid> */}

                            {/* <Grid item xs={12} md={6}>
                              <StyledTextField label="Enter your SurName" fullWidth />
                            </Grid> */}
                            <Grid item xs={12} md={6}>
                              <StyledTextField
                                label="Enter your Name"
                                fullWidth
                                size="small"
                                error={!!errors.name}
                                helperText={errors.name}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <StyledTextField
                                label="Enter Your SurName"
                                fullWidth
                                size="small"
                                error={!!errors.surname}
                                helperText={errors.surname}
                                value={surname}
                                onChange={(e) => setSurname(e.target.value)}
                              /></Grid>

                            <Grid item xs={12} md={6} >
                              {/* <Typography variant="body2" sx={{ color: "rgb(194, 185, 185)", mb: 1 }}>
                                Enter Mobile Number
                              </Typography> */}
                              <FormControl fullWidth error={!!errors.phone}>
                                <PhoneInput
                                  country={'in'}
                                  value={phone}
                                  onChange={setPhone}
                                  inputStyle={{
                                    width: '100%',
                                    height: '40px',
                                    borderColor: errors.phone ? '#d32f2f' : undefined,
                                  }}
                                  inputProps={{ name: 'phone', required: true }}
                                />
                                {errors.phone && <FormHelperText>{errors.phone}</FormHelperText>}
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <StyledTextField
                                label="Enter Your Email Id"
                                size="small"
                                fullWidth
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                error={!!errors.email}
                                helperText={errors.email}
                              />

                            </Grid>
                            {/* <Grid item xs={12} md={6}>
                              <StyledTextField
                                value={personalEmail}
                                onChange={(e) => setPersonalEmail(e.target.value)}
                                label="Enter your Personal Email Id"
                                error={!!errors.personalEmail}
                                helperText={errors.personalEmail}
                                size="small"
                                fullWidth /></Grid> */}
                            {/* <Grid item xs={12} md={6} sx={{ mt: { md: "-2%" } }}>
                              <Typography variant="body2" sx={{ color: "rgb(194, 185, 185)", mb: 1 }}>Enter Office Number </Typography>
                              <FormControl fullWidth error={!!errors.officeNumber}>
                                <PhoneInput
                                  country={'in'}
                                  value={officeNumber}
                                  onChange={setOfficeNumber}
                                  inputStyle={{ width: '100%', height: '40px' }}
                                  inputProps={{ name: 'officePhone', required: true, autoFocus: false }}
                                />
                                <FormHelperText>{errors.officeNumber}</FormHelperText>
                              </FormControl>
                            </Grid> */}
                            <Grid item xs={12} md={6}>
                              <Autocomplete
                                options={Gender}
                                getOptionLabel={(option) => option.name}
                                value={gender}
                                onChange={(e, v) => setGender(v)}
                                renderInput={(params) =>
                                  <StyledTextField {...params} label="Gender"
                                    error={!!errors.gender}
                                    helperText={errors.gender} fullWidth size="small" />
                                }
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Autocomplete
                                options={maritialstatus}
                                getOptionLabel={(option) => option.name}
                                value={marrital}
                                onChange={(e, value) => setMarrital(value)}
                                renderInput={(params) => (
                                  <StyledTextField
                                    {...params}
                                    error={!!errors.marrital}
                                    helperText={errors.marrital}
                                    label="Select Marital Status"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                  />
                                )}
                              />
                            </Grid>
                            {showSpouseFields && (
                              <>
                                <Grid item xs={12} md={6}>
                                  <StyledTextField label="Enter your Husband Name"
                                    value={husbandname}
                                    onChange={(e) => sethusbandName(e.target.value)}
                                    error={!!errors.husbandname}
                                    helperText={errors.husbandname}
                                    fullWidth size='small' />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <StyledTextField label="Enter your Husband Address"
                                    value={husbandAddress}
                                    error={!!errors.husbandAddress}
                                    helperText={errors.husbandAddress}
                                    onChange={(e) => setHusbandAddress(e.target.value)}
                                    fullWidth size='small' />
                                </Grid>
                                {/* <Grid item xs={12} md={6}>
                                    <StyledTextField label="Enter your Husband Number"
                                       value={husbandnumber}
                                          error={!!errors.husbandnumber}
                                    helperText={errors.husbandnumber}
                                    onChange={(e)=>setHusbandNumber(e.target.value)}
                                     fullWidth size='small' />
                                  </Grid> */}
                                <Grid item xs={12} md={6} sx={{ mt: "-3.5%" }}>
                                  <Typography variant="body2" sx={{ color: "rgb(194, 185, 185)", mb: 1 }}>
                                    Enter your Husband Number
                                  </Typography>
                                  <FormControl fullWidth error={!!errors.husbandnumber}>
                                    <PhoneInput
                                      country={'in'}
                                      value={husbandnumber}
                                      onChange={setHusbandNumber}
                                      inputStyle={{
                                        width: '100%',
                                        height: '40px',
                                        borderColor: errors.phone ? '#d32f2f' : undefined,
                                      }}
                                      inputProps={{ name: 'phone', required: true }}
                                    />
                                    {errors.husbandnumber && <FormHelperText>{errors.husbandnumber}</FormHelperText>}
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <StyledTextField label="Enter your Husband SurName"
                                    value={husbandsurname}
                                    error={!!errors.husbandsurname}
                                    helperText={errors.husbandsurname}
                                    onChange={(e) => sethusbandSurname(e.target.value)}
                                    fullWidth size='small' />
                                </Grid>
                              </>

                            )
                            }

                            {/* <Grid item xs={12} md={6}>
                              <Autocomplete options={countries}
                                getOptionLabel={(o) => o.countryName || ""}
                                onChange={handleCountryChange} value={formValues.country}
                                renderInput={(params) => <StyledTextField
                                  {...params}
                                  error={!!errors.country}
                                  helperText={errors.country}
                                  label="Country" fullWidth size="small" />}
                                disabled={isLoading || countries.length === 0} />
                            </Grid> */}
                            {/* <Grid item xs={12} md={6}>
                              <Autocomplete options={states}
                                getOptionLabel={(o) => o.stateName || ""}
                                onChange={handleStateChange}
                                value={formValues.state} renderInput={(params) =>
                                  <StyledTextField {...params}
                                    error={!!errors.state}
                                    helperText={errors.state}
                                    label="State" fullWidth size="small" />}
                                disabled={isLoading || !formValues.country || states.length === 0} />
                            </Grid> */}
                            {/* <Grid item xs={12} md={6}>
                              <Autocomplete options={districts}
                                getOptionLabel={(o) => o.districtName || ""}
                                value={formValues.distric} onChange={handleDistrictChange}
                                renderInput={(params) => <StyledTextField {...params} label="District"
                                  error={!!errors.distric}
                                  helperText={errors.distric}
                                  variant="outlined" size="small" fullWidth />} /></Grid> */}

                            {/* <Grid item xs={12} md={6}>
                              <Autocomplete options={cities}
                                getOptionLabel={(o) => o.cityName || ""}
                                value={formValues.city} onChange={handleCityChange}
                                renderInput={(params) =>
                                  <StyledTextField {...params}
                                    error={!!errors.city}
                                    helperText={errors.city}
                                    label="City" fullWidth size="small" />}
                                disabled={isLoading || !formValues.state || cities.length === 0} /></Grid> */}
                            <Grid item xs={12} md={6}>
                              <Autocomplete
                                options={states}
                                getOptionLabel={(o) => o.stateName || ""}
                                value={formValues.state}

                                onChange={handleStateChange}
                                renderInput={(params) => <StyledTextField
                                  {...params} label="State"
                                  error={!!errors.state}
                                  helperText={errors.state} fullWidth size='small' />}
                              />

                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Autocomplete
                                options={cities}
                                getOptionLabel={(o) => o.cityName || ""}
                                value={formValues.city}
                                onChange={handleCityChange}

                                renderInput={(params) => <StyledTextField {...params} label="City"
                                  error={!!errors.city}
                                  helperText={errors.city}
                                  fullWidth size='small' />}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Autocomplete options={branch}
                                getOptionLabel={(o) => o.name || ""}
                                value={seletedbranch}
                                onChange={(e, v) => setSelectedBranch(v)}
                                renderInput={(params) =>
                                  <StyledTextField {...params}
                                    error={!!errors.seletedbranch}
                                    helperText={errors.seletedbranch}
                                    label="Select branch" variant="outlined" size="small"
                                    fullWidth />} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Autocomplete options={religionlist}
                                getOptionLabel={(o) => o.religionName || ""}
                                value={selectedReligion}
                                onChange={(e, v) => setSelectedReligion(v)}
                                renderInput={(params) =>
                                  <StyledTextField {...params}
                                    error={!!errors.selectedReligion}
                                    helperText={errors.selectedReligion}
                                    label="Select Religion"
                                    variant="outlined" size="small" fullWidth />} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Autocomplete options={castelist}
                                getOptionLabel={(o) => o.castName || ""}
                                value={seletedCate} onChange={(e, v) => setSeletedCaste(v)}
                                renderInput={(params) => <StyledTextField {...params}
                                  error={!!errors.seletedCate}
                                  helperText={errors.seletedCate}
                                  label="Select Caste" variant="outlined" size="small"
                                  fullWidth />} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <StyledTextField type='date'
                                value={dateOfBirth}
                                error={!!errors.dateOfBirth}
                                helperText={errors.dateOfBirth}
                                onChange={(e) => setDateOfBirth(e.target.value)}
                                label="Date of Birth"
                                size="small"
                                fullWidth InputLabelProps={{ shrink: true }} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Autocomplete options={Educationlevel}
                                getOptionLabel={(o) => o.name}
                                value={education}
                                onChange={(e, v) => setEducation(v)}
                                renderInput={(params) =>
                                  <StyledTextField {...params}
                                    error={!!errors.education}
                                    helperText={errors.education}
                                    label="Select Education Level"
                                    variant="outlined" size="small" fullWidth />} />
                            </Grid>
                          </Grid>
                          {/* <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                            <Button
                              sx={{ ...styles.career }}
                              onClick={handlenext}
                            >
                              Next
                            </Button>

                          </Box> */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              gap: { xs: 1, md: "60%" },
                              mt: 2,
                            }}
                          >
                            <Button
                              sx={{ ...styles.careerButton }}
                              onClick={() => setTabValue(0)}
                            >
                              Back
                            </Button>
                            <Button
                              sx={{ ...styles.careerButton }}
                              onClick={handlenext}
                            >
                              Next
                            </Button>
                          </Box>
                        </Box>
                      </Card>
                    )}
                    {tabValue === 1 &&
                      <Card sx={{ ...styles.carrercardPopup, boxShadow: 10, p: 2 }}>
                        <DecorativeCorner sx={{ top: -20, left: -20 }} />
                        <DecorativeCorner sx={{ top: -20, right: -20 }} />
                        <DecorativeCorner sx={{ bottom: -20, right: -20 }} />
                        <DecorativeCorner sx={{ bottom: -20, left: -20 }} />
                        <Box sx={{ border: "2px solid #C1721F", padding: "20px" }}>

                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                              <Autocomplete options={educationList}
                                getOptionLabel={(o) => o.educationName || ""}
                                value={seletedEducationlist}
                                onChange={(e, v) => setEducationlist(v)}
                                renderInput={(params) =>
                                  <StyledTextField {...params} label="Select Education"
                                    error={!!errors.seletedEducationlist}
                                    helperText={errors.seletedEducationlist}
                                    variant="outlined" size="small" fullWidth />} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <StyledTextField label="Temp. Address"
                                value={address}
                                error={!!errors.address}
                                helperText={errors.address}
                                onChange={(e) => setAddress(e.target.value)}
                                size="small" fullWidth />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <StyledTextField
                                label="Enter your Aadhar No"
                                size="small"
                                fullWidth
                                value={aadhar}
                                onChange={handleAadharChange}
                                error={!!errors.aadhar}
                                helperText={errors.aadhar}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <StyledTextField label="Enter your Father Name"
                                value={fatherName}
                                error={!!errors.fatherName}
                                helperText={errors.fatherName}
                                onChange={(e) => setFatherName(e.target.value)}
                                size="small" fullWidth />
                            </Grid>
                            <Grid item xs={12} md={6} sx={{ mt: { md: "-2%" } }}>
                              <Typography variant="body2" sx={{ color: "rgb(194, 185, 185)", mb: 1 }}>Enter Your Father Mobile Number </Typography>
                              <FormControl fullWidth error={!!errors.fathernumber}>
                                <PhoneInput country={'in'}
                                  value={fathernumber}
                                  onChange={setFathernumber}
                                  inputStyle={{ width: '100%', height: '40px' }}
                                  inputProps={{ name: 'phone', required: true, autoFocus: false }} />
                                {errors.fathernumber && <FormHelperText>{errors.fathernumber}</FormHelperText>}
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} sx={{ mt: { md: "-2%" } }}>
                              <Typography variant="body2" sx={{ color: "rgb(194, 185, 185)", mb: 1 }}>Enter Reference Mobile Number </Typography>
                              <FormControl fullWidth error={!!errors.contactRefrencenumber}>
                                <PhoneInput country={'in'}
                                  value={contactRefrencenumber}
                                  onChange={setContactRefrenceNumber}
                                  inputStyle={{ width: '100%', height: '40px' }}
                                  inputProps={{ name: 'officePhone', required: true, autoFocus: false }} />
                                {errors.contactRefrencenumber && <FormHelperText>{errors.contactRefrencenumber}</FormHelperText>}

                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <StyledTextField
                                value={fatherAdress}
                                error={!!errors.fatherAdress}
                                helperText={errors.fatherAdress}
                                onChange={(e) => setFatherAdress(e.target.value)}
                                label="Enter your Father's Address"
                                size="small"
                                fullWidth
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <StyledTextField
                                value={referenceName}
                                onChange={(e) => setReferenceName(e.target.value)}
                                error={!!errors.referenceName}
                                helperText={errors.referenceName}
                                label="Enter your Refrence Name"
                                size="small" fullWidth />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <StyledTextField
                                value={referenceAddress}
                                error={!!errors.referenceAddress}
                                helperText={errors.referenceAddress}
                                onChange={(e) => setReferenceAddress(e.target.value)}
                                label="Enter your Refrence Address"
                                size="small" fullWidth />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Autocomplete options={source}
                                getOptionLabel={(o) => o.sourceName || ""}
                                value={seletedsource}
                                onChange={(e, value) => setSeletedSource(value)}
                                renderInput={(params) =>

                                  <StyledTextField {...params} label="Select Source"
                                    error={!!errors.seletedsource}
                                    helperText={errors.seletedsource}
                                    variant="outlined" size="small" fullWidth />} />
                            </Grid>
                            {/* <Grid item xs={12} md={6}>
                              <StyledTextField
                                type="date"
                                value={joiningDate}
                                error={!!errors.joiningDate}
                                helperText={errors.joiningDate}
                                onChange={(e) => setJoiningDate(e.target.value)}
                                label="Joining Date"
                                fullWidth size="small"
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid> */}

                            <Grid item xs={12} md={6}>
                              <StyledTextField
                                label="EXP years"
                                size="small"
                                fullWidth
                                value={expYears}
                                onChange={handleNumberInput(setExpYears)}
                                error={!!errors.expYears}
                                helperText={errors.expYears}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <StyledTextField
                                label="EXP Months"
                                size="small"
                                fullWidth
                                value={expMonths}
                                onChange={handleNumberInput(setExpMonths)}
                                error={!!errors.expMonths}
                                helperText={errors.expMonths}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Autocomplete
                                options={StatusList}
                                getOptionLabel={(option) => option.name}
                                value={status}
                                onChange={(e, value) => setStatus(value)}

                                renderInput={(params) => (
                                  <StyledTextField {...params}
                                    error={!!errors.status}
                                    helperText={errors.status}
                                    label="Select Status" variant="outlined" size="small" fullWidth />
                                )}
                              />
                            </Grid>
                          </Grid>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              gap: { xs: 1, md: "60%" },
                              mt: 2,
                            }}
                          >

                            <Button
                              sx={{ ...styles.careerButton }}
                              onClick={() => setTabValue(0)}
                            >
                              Back
                            </Button>
                            <Button
                              sx={{ ...styles.careerButton }}
                              onClick={handleNext}
                            >
                              Next
                            </Button>
                          </Box>

                        </Box>
                      </Card>
                    }
                    {tabValue === 2 &&
                      <Card sx={{ ...styles.carrercardPopup, boxShadow: 10, p: 2 }}>
                        <DecorativeCorner sx={{ top: -20, left: -20 }} />
                        <DecorativeCorner sx={{ top: -20, right: -20 }} />
                        <DecorativeCorner sx={{ bottom: -20, right: -20 }} />
                        <DecorativeCorner sx={{ bottom: -20, left: -20 }} />
                        <Box sx={{ border: "2px solid #C1721F", padding: "20px" }}>
                          <Grid container spacing={0}>
                            <Grid
                              item
                              xs={12}
                              md={6}
                              sx={{
                                mb: 2,

                              }}
                            >
                              <Box sx={{ textAlign: 'center' }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, fontFamily: '"Inter var"', }}>
                                  Upload Your Ssc Certificate    </Typography>
                                <Box
                                  sx={{
                                    width: "80%",
                                    height: 120,
                                    border: '2px dashed #ccc',
                                    overflow: 'hidden',
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: 2,
                                    mx: 'auto',
                                  }}
                                >
                                  {sscimage ? (
                                    <img
                                      // src={sscimage}
                                      src={URL.createObjectURL(sscimage)}
                                      alt="Uploaded"
                                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                  ) : (
                                    <Box
                                      sx={{
                                        width: '100%',
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <CloudUploadIcon sx={{ fontSize: 40, color: '#C1721F' }} />
                                    </Box>//#999 color
                                  )}
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={Scchandlechange}
                                    style={{
                                      opacity: 0,
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      height: '100%',
                                      width: '100%',
                                      cursor: 'pointer',
                                    }}
                                  />
                                </Box>
                              </Box>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              md={6}
                              sx={{
                                mb: 2,

                              }}
                            >
                              <Box sx={{ textAlign: 'center' }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, fontFamily: '"Inter var"', }}>
                                  Upload Your Higher Certificate   </Typography>
                                <Box
                                  sx={{
                                    width: "80%", height: 120,
                                    border: '2px dashed #ccc',
                                    overflow: 'hidden',
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: 2,
                                    mx: 'auto',
                                  }}
                                >
                                  {HigherCertificate ? (
                                    <img
                                      // src={HigherCertificate}
                                      src={URL.createObjectURL(HigherCertificate)}
                                      alt="Uploaded"
                                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                  ) : (
                                    <Box
                                      sx={{
                                        width: '100%',
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <CloudUploadIcon sx={{ fontSize: 40, color: '#C1721F' }} />
                                    </Box>
                                  )}
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={HigherCertificatehandlechange}
                                    style={{
                                      opacity: 0,
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      height: '100%',
                                      width: '100%',
                                      cursor: 'pointer',
                                    }}
                                  />
                                </Box>
                              </Box>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              md={6}
                              sx={{
                                mb: 2,

                              }}
                            >
                              <Box sx={{ textAlign: 'center' }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, fontFamily: '"Inter var"', }}>
                                  Upload Your Aadhar Card   </Typography>
                                <Box
                                  sx={{
                                    width: "80%", height: 120,
                                    border: '2px dashed #ccc',
                                    overflow: 'hidden',
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: 2,
                                    mx: 'auto',
                                  }}
                                >
                                  {AadharCard ? (
                                    <img
                                      // src={AadharCard}
                                      src={URL.createObjectURL(AadharCard)}
                                      alt="Uploaded"
                                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                  ) : (
                                    <Box
                                      sx={{
                                        width: '100%',
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <CloudUploadIcon sx={{ fontSize: 40, color: '#C1721F' }} />
                                    </Box>
                                  )}
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={AadharCardhandlechange}
                                    style={{
                                      opacity: 0,
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      height: '100%',
                                      width: '100%',
                                      cursor: 'pointer',
                                    }}
                                  />
                                </Box>
                              </Box>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              md={6}
                              sx={{
                                mb: 2,

                              }}
                            >
                              <Box sx={{ textAlign: 'center' }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, fontFamily: '"Inter var"', }}>
                                  Upload Your Pan card   </Typography>
                                <Box
                                  sx={{
                                    width: "80%", height: 120,
                                    border: '2px dashed #ccc',
                                    overflow: 'hidden',
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: 2,
                                    mx: 'auto',
                                  }}
                                >
                                  {Pancard ? (
                                    <img
                                      // src={Pancard}
                                      src={URL.createObjectURL(Pancard)}
                                      alt="Uploaded"
                                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                  ) : (
                                    <Box
                                      sx={{
                                        width: '100%',
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <CloudUploadIcon sx={{ fontSize: 40, color: '#C1721F' }} />
                                    </Box>
                                  )}
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={Pancardhandlechange}
                                    style={{
                                      opacity: 0,
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      height: '100%',
                                      width: '100%',
                                      cursor: 'pointer',
                                    }}
                                  />
                                </Box>
                              </Box>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              md={6}
                              sx={{
                              }}
                            >
                              <Box sx={{ textAlign: 'center' }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, fontFamily: '"Inter var"', }}>
                                  Upload Your Bank PassBook
                                </Typography>
                                <Box
                                  sx={{
                                    width: "80%", height: 120,
                                    border: '2px dashed #ccc',
                                    overflow: 'hidden',
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: 2,
                                    mx: 'auto',
                                  }}
                                >
                                  {BankPassBook ? (
                                    <img
                                      // src={BankPassBook}
                                      src={URL.createObjectURL(BankPassBook)}
                                      alt="Uploaded"
                                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                  ) : (
                                    <Box
                                      sx={{
                                        width: '100%',
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <CloudUploadIcon sx={{ fontSize: 40, color: '#C1721F' }} />
                                    </Box>
                                  )}
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={PassBookhandlechange}
                                    style={{
                                      opacity: 0,
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      height: '100%',
                                      width: '100%',
                                      cursor: 'pointer',
                                    }}
                                  />
                                </Box>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                        {/* <Button onClick={handleSubmit}>
                          submite
                        </Button> */}
                        {/* <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                          <Button
                            sx={{ ...styles.career }}
                            onClick={handleSubmit}
                          >
                            submite
                          </Button>
                        </Box> */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            gap: { xs: 1, md: "60%" },
                            mt: 2,
                          }}
                        >
                          {/* <Button
                              sx={{ ...styles.career }}
                              onClick={() => setTabValue(1)}
                            >
                              Back
                            </Button> */}
                          <Button
                            sx={{ ...styles.career }}
                            onClick={handleSubmit}
                          >
                            submite
                          </Button>
                        </Box>
                      </Card>
                    }
                  </DialogContent>
                </Dialog>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>

      <Footer />
    </>
  );
};

export default Careers;
